export interface RegistrationSponsorProps {
  isFieldDisabled: boolean;
  showABOSelected: boolean;
  isFocused?: boolean;
  wrapperClass?: string;
  doNotKnowAboFlowType?: DoNotKnowSponsorFlow;
  state?: string;
  city?: string;
  onLeadsSearchHandler?: (value: boolean) => void;
}

export enum DoNotKnowSponsorFlow {
  OFF = 'OFF',
  RANDOM = 'RANDOM',
  POSTAL_CODE_SEARCH = 'POSTAL_CODE_SEARCH',
  WITHOUT_POSTAL_CODE_SEARCH = 'WITHOUT_POSTAL_CODE_SEARCH',
  RANDOM_WITH_SPONSOR_INFO = 'RANDOM_WITH_SPONSOR_INFO',
}

export interface RegisterationSponsorRef {
  validateSponsor: () => void;
  resetSponsorValidation: () => void;
}
